/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useClientPrivacyPolicy = (queryParams) => {
  return useQuery({
    queryKey: queryKeys.client.privacyPolicy,
    queryFn: () => fetcher({ method: "GET", url: "/public/clients/privacy-policy" }),
    ...queryParams,
  });
};
